import React, { useEffect, useState } from 'react'
import AppHeader from '../../components/AppHeader'
import portalServices from '../../portalServices';
import { Link, useNavigate } from 'react-router-dom';

import { Step, StepLabel, Stepper } from '@mui/material';
import { ArrowCircleRight } from '@mui/icons-material';
import QueueWorkingHours from '../../components/QueueWorkingHours';
import CheckinBackButton from '../CheckinBackButton';
const Step1 = () =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={0}>
        <Step>
          <StepLabel>Select Queue</StepLabel>
        </Step>
        <Step>
          <StepLabel>Select Time Slot And Service</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}


function SelectSlotQueuePage() {

  const navigate = useNavigate();
  const [queuList,setQueueList] = useState(null);
  const getQueueList = () =>{
    portalServices.getTimeSlotQueueList().then(res=>{
      setQueueList(res.data);
    }).catch(error=>{

    })
  }
  useEffect(()=>{
    getQueueList();
  },[])

  const selectQueue = (queue) =>{
    navigate("/slot-checkin/services",{state:queue})
  }
  return (
    <>
        <AppHeader/>
        <div className='container'>
            <div className='row'>
                <CheckinBackButton/>
                <Step1/>
                <div className='col-md-12'>
                    {queuList && queuList.map(queue=>
                      <div key={queue.id} className="card px-3 py-3 mb-2" type="button">
                          <div className='fw-bold'>{queue.title}</div>
                          <div className='mt-2'>
                            <QueueWorkingHours queue={queue} />
                            <button className='btn btn-success' onClick={()=>selectQueue(queue)}>Book My Slot</button>
                          </div>
                      </div>
                    )}
                </div>
            </div>
        </div>
    </>
  )
}

export default SelectSlotQueuePage